export enum DeliveryMethodEnum {
    AddressDelivery = 1,
    StorePickup = 2,
    PickPoint = 30,
}
